import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-eventandentertainment',
  templateUrl: './eventandentertainment.component.html',
  styleUrls: ['./eventandentertainment.component.scss']
})
export class EventandentertainmentComponent implements OnInit {
  safeURL;

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {

    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Event and Entertainment surveys help you to monitor your event before, during, and after the event. Know how our event feedback survey can help get ready insights on audience opinions of your event.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Event attendance survey , Event evaluation survey , Event Feedback Survey , Event survey app , Entertainment survey , Event feedback survey , Event survey , Event survey feedback questions , Event survey templates , Entertainment , Post event survey customer  , Event exit survey questions' }
    ]);

    this.setTitle('Event And Entertainment Survey | Event Feedback Survey');
    // End SEO Meta Description


    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description

  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();  
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
